import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContent4UpVideo";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const errorMessages = checkItemArrayIntegrity(items, ["id", "headline"]);
    errorMessages.push(...checkMediaIntegrity(items, MEDIA_PRIORITY));

    return errorMessages;
}
